import Vue from 'vue'
import VueRouter from 'vue-router'
import PC from '../views/PC/index.vue'
import mobile from '../views/mobile/index.vue'
import gold from '../views/PC/gold.vue'
import goldM from '../views/mobile/gold.vue'
import landing1 from '../views/landing1.vue'
import landing2 from '../views/landing2.vue'
import landing3 from '../views/landing3.vue'
import landing4 from '../views/landing4.vue'
import landing5 from '../views/landing5.vue'
import landing6 from '../views/landing6.vue'
import landing7 from '../views/landing7.vue'
import landing8 from '../views/landing8.vue'
import landing9 from '../views/landing9.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index.html',
    redirect: '/'
  },
  {
    path: '/',
    name: 'PC',
    component: PC
  },
  {
    path: '/mobile/',
    name: 'mobile',
    component: mobile
  },
  {
    path: '/gold/',
    name: 'gold',
    component: gold,
    meta: { title: '黄金城争覇戦イベント規約 | 「最強三国　黄金城の決戦」事前登録受付中！' }
  },
  {
    path: '/goldM/',
    name: 'goldMobile',
    component: goldM,
    meta: { title: '黄金城争覇戦イベント規約 | 「最強三国　黄金城の決戦」事前登録受付中！' }
  },
  {
    path: '/landing1/',
    name: 'landing1',
    component: landing1,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/landing3/',
    name: 'landing3',
    component: landing3,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/landing2/',
    name: 'landing2',
    component: landing2,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/landing4/',
    name: 'landing4',
    component: landing4,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/landing5/',
    name: 'landing5',
    component: landing5,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/landing6/',
    name: 'landing6',
    component: landing6,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/landing7/',
    name: 'landing7',
    component: landing7,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/launch-cpp1-FB/',
    name: 'landing8',
    component: landing8,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: '/launch-cpp9-FB/',
    name: 'landing9',
    component: landing9,
    meta: { title: '【最強三国~黄金城の決戦】事前登録受付中!' }
  },
  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // chrome
  // document.body.scrollTop = 0
  // firefox
  // document.documentElement.scrollTop = 0
  // safari
  // window.pageYOffset = 0

  if (to.meta.title) {
    document.title = to.meta.title
  }

  let docEl = document.documentElement;
  let clientWidth = docEl.clientWidth;
  if (!clientWidth) { 
      return
  }
  if(clientWidth < 751){
    if(to.path === '/') {
      next('/mobile/')
    }
  }else{
    if(to.path === '/mobile/') {
      next('/')
    }
  }
  next()
})

export default router
